export const stripHyphens = stringValue => {
  return stringValue.replace(/-/g, '')
}

export const convertHyphensToSpace = stringValue => {
  return stringValue.replace(/-/g, ' ')
}
